import * as actionTypes from "../actionTypes/Index";
import { authInitialState } from "./InitialState";
import { IActionType } from "../../interfaces/Index";

const initialState = { ...authInitialState };

export default function authReducer(state = initialState, action: IActionType) {
  switch (action.type) {
    case actionTypes.LOGIN_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
      });
    }
    case actionTypes.LOGIN_SUCCESS: {
      return Object.assign(
        {},
        state,
        {
          isLoading: false,
        },
        action.payload
      );
    }
    case actionTypes.LOGIN_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
      });
    }
    case actionTypes.GET_MFA_SESSION_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        mfa: null,
      });
    }
    case actionTypes.GET_MFA_SESSION_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        error: null,
        mfa: action.payload,
      });
    }
    case actionTypes.GET_MFA_SESSION_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
      });
    }
    case actionTypes.VALIDATE_MFA_SESSION_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        isValidateMFASuccess: false,
      });
    }
    case actionTypes.VALIDATE_MFA_SESSION_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        error: null,
        mfa: { ...state.mfa, token: (action.payload as any).mfaToken },
        isValidateMFASuccess: true,
      });
    }
    case actionTypes.VALIDATE_MFA_SESSION_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
        isValidateMFASuccess: false,
      });
    }
    case actionTypes.MFA_FALLBACK_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        isValidateMFASuccess: false,
      });
    }
    case actionTypes.MFA_FALLBACK_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        error: null,
        mfa: { ...state.mfa, token: (action.payload as any).mfaToken },
        isValidateMFASuccess: false,
      });
    }
    case actionTypes.MFA_FALLBACK_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
        isValidateMFASuccess: false,
      });
    }
    default:
      return state;
  }
}
